<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '840px'}"
  styleClass="p-fluid comunica-contributo-dialog"
  [showHeader]="false"
  (onHide)="hide()">

  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-history header-icon"></i>
        <h4>Storico richiesta del <span class="font-bold">{{ richiesta?.enteEsecutore?.label | uppercase }}</span> per l'anno</h4>
        <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
          <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ richiesta?.anno }}</span>
        </div>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="hide()">
      </button>
    </div>

    <div class="dialog-content">
      <div class="storico-container">
        <div class="loading-container" *ngIf="isLoading">
          <ng-lottie
            class="loader-lottie"
            [options]="lottieConfig"
          ></ng-lottie>
        </div>

        <div *ngIf="!isLoading" class="timeline-container">
          <p-timeline [value]="eventi">
            <ng-template pTemplate="marker" let-evento>
              <span
                class="material-symbols-outlined small-icon"
                [ngStyle]="{'color': stiliService.getColoreIconaStatoRichiesta(evento.richiesta)}"
                >
                {{ stiliService.getMaterialIconStoricoRichiesta(evento) }}
              </span>
            </ng-template>
            <ng-template pTemplate="opposite" let-evento>
              <span [style.color]="stiliService.getColoreIconaStatoRichiesta(evento.richiesta)">{{ evento.stato.descrizione }}</span>
            </ng-template>
            <ng-template pTemplate="content" let-evento>
              <small>{{ (evento.dataFine ? evento.dataFine : evento.dataInizio) | date:'dd/MM/yyyy' }}</small>
            </ng-template>
          </p-timeline>
        </div>
      </div>
    </div>

    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="hide()">
      </button>
    </div>
  </div>
</p-dialog>
